import { Card, Button, Modal, Collapse } from "react-bootstrap";
import {
  FiPlus,
  FiMaximize2,
  FiTrash2,
  FiX,
  FiChevronDown,
  FiChevronUp,
} from "react-icons/fi";
import { useRef, useState } from "react";

const ImagesSection = () => {
  const [images, setImages] = useState([
    "/assets/img/media/media-08.jpg",
    "/assets/img/media/media-09.jpg",
    "/assets/img/media/media-10.jpg",
    "/assets/img/media/media-11.jpg",
    "/assets/img/media/media-12.jpg",
    "/assets/img/media/media-13.jpg",
  ]);

  const [open, setOpen] = useState(true);
  const [showViewer, setShowViewer] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const fileInputRef = useRef();

  const handleUpload = (e) => {
    const files = Array.from(e.target.files);
    const newImgs = files.map((file) => URL.createObjectURL(file));
    setImages((prev) => [...prev, ...newImgs]);
  };

  const handleDelete = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const openViewer = (index) => {
    setCurrentIndex(index);
    setShowViewer(true);
  };

  const next = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  return (
    <>
      <Card className="custom-card">
        <Card.Body>

          {/* HEADER */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6>Images</h6>

            <div className="d-flex align-items-center">
              <Button
                className="btn-orange btn-sm me-3"
                onClick={() => fileInputRef.current.click()}
              >
                <FiPlus /> Add New
              </Button>

              {/* TOGGLE ICON */}
              <div onClick={() => setOpen(!open)} style={{ cursor: "pointer" }}>
                {open ? (
                  <FiChevronUp className="toggle-icon" />
                ) : (
                  <FiChevronDown className="toggle-icon" />
                )}
              </div>
            </div>

            <input
              type="file"
              hidden
              multiple
              ref={fileInputRef}
              onChange={handleUpload}
            />
          </div>

          {/* ✅ COLLAPSE (NO DESIGN CHANGE) */}
          <Collapse in={open}>
            <div>
              <div className="image-grid">
                {images.map((img, i) => (
                  <div className="img-box" key={i}>
                    <img src={img} alt="img" />

                    <div className="img-overlay">
                      <button onClick={() => openViewer(i)}>
                        <FiMaximize2 />
                      </button>
                      <button onClick={() => handleDelete(i)}>
                        <FiTrash2 />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Collapse>

        </Card.Body>
      </Card>

      {/* MODAL (UNCHANGED) */}
      <Modal
        show={showViewer}
        onHide={() => setShowViewer(false)}
        centered
        fullscreen
        className="image-modal"
      >
        <Modal.Body className="viewer-body">

          <div className="viewer-header">
            <span
              className="back-btn text-white pe-2"
              onClick={() => setShowViewer(false)}
            >
              ← Back
            </span>

            <span
              className="close-btn"
              onClick={() => setShowViewer(false)}
            >
              <FiX />
            </span>
          </div>

          <img
            src={images[currentIndex]}
            className="viewer-img"
            alt="preview"
          />

          <span className="nav left" onClick={prev}>‹</span>
          <span className="nav right" onClick={next}>›</span>

        </Modal.Body>
      </Modal>

      {/* STYLES (ONLY SMALL CLEANUP) */}
      <style>{`
        .custom-card {
        border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
        }

        .btn-orange {
          background: #ff6b2c;
          border: none;
        }

        .toggle-icon {
          font-size: 18px;
        }

        .image-grid {
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
        }

        .img-box {
          position: relative;
          width: 170px;
          height: 120px;
          border-radius: 10px;
          overflow: hidden;
        }

        .img-box img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .img-overlay {
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.45);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          opacity: 0;
          transition: 0.3s;
        }

        .img-box:hover .img-overlay {
          opacity: 1;
        }

        .img-overlay button {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: none;
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .image-modal .modal-content {
          background: rgba(0,0,0,0.95);
          border: none;
        }

        .viewer-body {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100vh;
        }

        .viewer-img {
          max-width: 80%;
          max-height: 80vh;
          object-fit: contain;
        }

        .close-btn {
          position: absolute;
          top: 20px;
          right: 30px;
          font-size: 30px;
          color: white;
          cursor: pointer;
        }

        .nav {
          position: absolute;
          top: 50%;
          font-size: 60px;
          color: white;
          cursor: pointer;
          transform: translateY(-50%);
        }

        .nav.left {
          left: 40px;
        }

        .nav.right {
          right: 40px;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .img-box {
            width: 48%;
            height: 100px;
          }

          .image-grid {
            overflow-x: auto;
            flex-wrap: nowrap;
          }

          .img-box {
            min-width: 140px;
          }

          .nav {
            font-size: 35px;
          }
        }
      `}</style>
    </>
  );
};

export default ImagesSection;